import React from "react";
import { Route } from "react-router-dom";
import PlmHomePage from "../../components/plm/PlmHomePage";
import PlmWeek from "../../components/plm/PlmWeek";
import PLM_WEEKS from "../../components/plm/plmWeeks";
import gameRoutes from "./gameRoutes";

// PLM replaces the GeriActive view rather than adding to it: when a user holds
// PLM, these are the only routes registered, so GeriActive pages fall through
// to the "*" catch-all below and land on the PLM homepage.
const plmRoutes = [
  ...PLM_WEEKS.map((week) => (
    <Route
      path={week.path}
      key={week.key}
      element={<PlmWeek week={week.week} />}
    />
  )),
  ...gameRoutes,
  <Route path="/home" key="plm-home" element={<PlmHomePage />} />,
  <Route path="/" key="plm-home-start" element={<PlmHomePage />} />,
  <Route path="*" key="plm-home-page" element={<PlmHomePage />} />,
];

export default plmRoutes;
